import {
    Button, Card, CardContent, CardHeader, Dialog, DialogContent, DialogTitle,
    Divider, Grid, IconButton, Slide, TextField, Tooltip, Typography, useTheme
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { IconCircleX } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { forwardRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    getAGPOption,
    getAnticocidalOption,
    getCustomerOption,
    getDistrictOption,
    getLocationOption,
    getProbioticOption,
    getRegionOption,
    getStateOption,
    getTechnicalManagerOption,
    setFarmRecordsFilteredData
} from "store/app/farm-management/farm-records/actions";
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { IconInfoCircleFilled } from "@tabler/icons-react";
import VWDropdown from "components/dropdown";
import { useSearchParams } from "react-router-dom";
import { unionBy } from 'lodash';

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}
const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterUsers = (props) => {

    const { open, onClose, farmRecordsFilterData } = props;

    const theme = useTheme();
    //eslint-disable-next-line
    const [searchParams, setSearchParmas] = useSearchParams();
    const filterObject = Object.fromEntries([...searchParams.entries()].map(([key, value]) => [
        key?.toLowerCase(),
        value?.toLowerCase(),
    ]));

    const [errors, setErrors] = useState();
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (farmRecordsFilterData) {
            setFilter(farmRecordsFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);

    //--------------------Technical Manager---------------------------
    const [technicalManagerOptions, setTechnicalManagerOptions] = useState([]);
    const [selectedManager, setSelectedManager] = useState([]);

    const loadTechnicalManagerOption = (filter, page, pageSize) => {
        return props.getTechnicalManagerOption(filter, page, pageSize)
    }

    useEffect(() => {
        if (filter?.technicalmanageremail) {
            loadTechnicalManagerOption(filter?.technicalmanageremail)
                .then((result) => {
                    setSelectedManager(result);
                });
        }
    }, [filter?.technicalmanageremail])

    //--------------------Customer------------------------------------
    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);

    const loadCustomerOptions = (filter, page, pageSize) => {
        return props.getCustomerOption(filter, page, pageSize)
    }

    useEffect(() => {
        if (filter?.customer) {
            loadCustomerOptions(filter?.customer)
                .then((result) => {
                    setSelectedCustomer(result);
                });
        }
    }, [filter?.customer])

    //--------------------Region--------------------------------------
    const [regionOptions, setRegionOptions] = useState([]);
    const loadRegionOptions = (filter, page, pageSize) => {
        return props.getRegionOption(filter, "filter", page, pageSize)
    }

    //--------------------Location------------------------------------
    const [locationOptions, setLocationOptions] = useState([]);
    const loadLocationOption = (filter) => {
        return props.getLocationOption(filter, filter?.recordstatus)
    }

    //--------------------State---------------------------------------
    const [stateOptions, setStateOptions] = useState([]);
    const loadStateOption = (state, page, pageSize) => {
        return props.getStateOption(state, filter?.region, page, pageSize)
    }

    //--------------------District------------------------------------
    const [districtOptions, setDistrictOptions] = useState([]);
    const loadDistrictOption = (district, page, pageSize) => {
        return props.getDistrictOption(district, filter?.state, filter?.region, page, pageSize)
    }

    //--------------------Anticocidal---------------------------------
    const [anticoccidialOptions, setAnticoccidialOptions] = useState([]);
    const loadAnticoccidialOption = (filter, page, pageSize) => {
        return props.getAnticocidalOption(filter, page, pageSize)
    }

    //--------------------AGP-----------------------------------------
    const [agpOptions, setAgpOptions] = useState([]);
    const loadAgpOption = (filter, page, pageSize) => {
        return props.getAGPOption(filter, page, pageSize)
    }

    //--------------------Probiotic-----------------------------------
    const [probioticOptions, setProbioticOptions] = useState([]);
    const loadProbioticOption = (filter, page, pageSize) => {
        return props.getProbioticOption(filter, page, pageSize)
    }

    useEffect(() => {
        setErrors();
    }, [open]);

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        if ((name === "totalBirdImageCount" || name === "examinedbirdscount" || name === "totalnoofbirdsplaced") && Number(value) > 10000000) {
            return;
        }
        setFilter({
            ...filter,
            [name]: value,
        });
    }
    const validateOnDate = (name, date) => {
        const formattedDate = date ? moment(date).format("DD-MM-YYYY") : null;
        setFilter({
            ...filter,
            [name]: formattedDate,
        });
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleTechnicalManagerSelect = (option) => {
        const optionArray = option?.map((field) => {
            if (field.label) {
                const { label } = field || {};
                const splitLabel = label?.split('|');
                const technicalmanagerusername = splitLabel?.length > 0 ? splitLabel[0]?.trim() : null;
                const technicalmanageruseremail = splitLabel?.length > 0 ? splitLabel[1]?.trim() : null;
                return { technicalmanagerusername, technicalmanageruseremail }
            }
            else {
                const splitLabel = field?.split('|');
                const technicalmanagerusername = splitLabel?.length > 0 ? splitLabel[0]?.trim() : null;
                const technicalmanageruseremail = splitLabel?.length > 0 ? splitLabel[1]?.trim() : null;
                return { technicalmanagerusername, technicalmanageruseremail }
            }
        });
        const optionTechnicalmanageruseremail = optionArray?.map((field) => field.technicalmanageruseremail);
        const optionStringTechnicalmanageruseremail = optionTechnicalmanageruseremail?.length > 0 ? optionTechnicalmanageruseremail.join() : null;
        setFilter({
            ...filter,
            technicalmanageremail: optionStringTechnicalmanageruseremail,
        });
    }

    const handleCustomerSelect = (option) => {
        const optionArray = option?.map((field) => {
            if (field.label) {
                const { label } = field || {};
                const splitLabel = label?.split('|');
                const customerName = splitLabel?.length > 0 ? splitLabel[0]?.trim() : null;
                const customerEmail = splitLabel?.length > 0 ? splitLabel[1]?.trim() : null;
                return { customerName, customerEmail }
            }
            else {
                const splitLabel = field?.split('|');
                const customerName = splitLabel?.length > 0 ? splitLabel[0]?.trim() : null;
                const customerEmail = splitLabel?.length > 0 ? splitLabel[1]?.trim() : null;
                return { customerName, customerEmail }
            }
        });
        const optionCustomerEmail = optionArray?.map((field) => field.customerEmail);
        const optionStringCustomerEmail = optionCustomerEmail?.length > 0 ? optionCustomerEmail.join() : null;
        setFilter({
            ...filter,
            customer: optionStringCustomerEmail,
        });
    }
    const handleSelect = (option, name) => {
        const optionArray = option?.map((field) => field.label ? field.label : field);
        const optionString = optionArray?.length > 0 ? optionArray.join() : null;
        if (name === "region") {
            setFilter({
                ...filter,
                [name]: optionString,
                state: null,
                district: null,
            });
            setStateOptions([]);
            setDistrictOptions([]);
        }
        else if (name === "state") {
            setFilter({
                ...filter,
                [name]: optionString,
                district: null,
            });
            setDistrictOptions([]);
        }
        else {
            setFilter({
                ...filter,
                [name]: optionString,
            });
        }
    }

    const updateIfDifferent = (filterObj, paramsObj) => {
        let updated = false;
        for (const key of Object.keys(paramsObj)) {
            if (key in filterObj && paramsObj[key] !== filterObj[key]) {
                paramsObj[key] = filterObj[key];
                updated = true;
            }
        }

        return updated ? { ...paramsObj } : paramsObj;
    }

    const handleFilter = (e) => {
        e.preventDefault();
        const { fromdate, todate, submittedfrom, submittedto } = filter || {};
        let currentErrors = {};
        if (fromdate) {
            if (fromdate === "Invalid date") {
                currentErrors.fromdate = "From date is invalid";
            }
            if (!todate) {
                currentErrors.todate = "To date is required";
            }
        }
        if (todate) {
            if (todate === "Invalid date") {
                currentErrors.todate = "To date is invalid";
            }
            if (!fromdate) {
                currentErrors.fromdate = "From date is required";
            }
        }
        if (submittedfrom) {
            if (submittedfrom === "Invalid date") {
                currentErrors.submittedfrom = "From date is invalid";
            }
            if (!submittedto) {
                currentErrors.submittedto = "To date is required";
            }
        }
        if (submittedto) {
            if (submittedto === "Invalid date") {
                currentErrors.submittedto = "To date is invalid";
            }
            if (!submittedfrom) {
                currentErrors.submittedfrom = "From date is required";
            }
        }

        setErrors(currentErrors);
        if (Object.keys(currentErrors).length === 0) {
            const nonEmptyData = removeEmptyKeys(filter);
            const paramsKey = filterObject ? Object.keys(filterObject) : [];
            const missingKey = paramsKey.filter(key => !(key in nonEmptyData));
            missingKey?.map((key) => delete filterObject[key]);
            if (filterObject?.src) {
                delete filterObject.src;
            }
            const compareFilter = (nonEmptyData && filterObject) ? updateIfDifferent({ ...nonEmptyData }, { ...filterObject }) : {};
            setSearchParmas(compareFilter);
            props.setFarmRecordsFilteredData(nonEmptyData);
            onClose();
        }
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        props.setFarmRecordsFilteredData({ recordstatus: farmRecordsFilterData?.recordstatus });
        setSearchParmas();
        onClose();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 650,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={4} columnSpacing="16" direction={'row'}  >
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    autoFocus
                                                    sx={styles}
                                                    label="Record No."
                                                    fullWidth
                                                    size="small"
                                                    name='recordno'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    value={filter?.recordno || ""}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Farm Name"
                                                    fullWidth
                                                    size="small"
                                                    name='farmname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.farmname}
                                                />
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12}>
                                                <VWDropdown
                                                    label="Technical Manager"
                                                    name="technicalmanageremail"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadTechnicalManagerOption}
                                                    onSelect={handleTechnicalManagerSelect}
                                                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                    selectedOption={filter?.technicalmanageremail ? selectedManager : []}
                                                    options={technicalManagerOptions}
                                                    setOptions={(options) => {
                                                        setTechnicalManagerOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12}>
                                                <VWDropdown
                                                    label="Customer"
                                                    name="customer"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadCustomerOptions}
                                                    onSelect={handleCustomerSelect}
                                                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                    selectedOption={filter?.customer ? selectedCustomer : []}
                                                    options={customerOptions}
                                                    setOptions={(options) => {
                                                        setCustomerOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12}>
                                                <Card sx={{ border: `2px solid ${theme.palette.primary.light}`, pt: 1 }}>
                                                    <CardHeader
                                                        sx={{ p: 1 }}
                                                        title={
                                                            <Grid item sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                <Typography variant="inherit" sx={{ fontWeight: "500", fontSize: "17px" }}>
                                                                    Inspection Date
                                                                </Typography>
                                                                <Tooltip title="Inspection date filter need both from and to date." placement="top" arrow>
                                                                    <IconInfoCircleFilled style={{ color: "gray", cursor: "pointer" }} />
                                                                </Tooltip>
                                                            </Grid>
                                                        }
                                                    />
                                                    <CardContent sx={{ p: 1, pt: 1 }}>
                                                        <Grid container columnSpacing="16">
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="From Date"
                                                                        onChange={(date) => validateOnDate("inspectedfrom", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.inspectedfrom ? moment.utc(filter.inspectedfrom, "DD-MM-YYYY") : null}
                                                                        maxDate={filter?.inspectedto ? moment.utc(filter.inspectedto, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.inspectedfrom,
                                                                                helperText: errors?.inspectedfrom
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="To Date"
                                                                        onChange={(date) => validateOnDate("inspectedto", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.inspectedto ? moment.utc(filter.inspectedto, "DD-MM-YYYY") : null}
                                                                        minDate={filter?.inspectedfrom ? moment.utc(filter.inspectedfrom, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.inspectedto,
                                                                                helperText: errors?.inspectedto
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12}>
                                                <Card sx={{ border: `2px solid ${theme.palette.primary.light}`, pt: 1 }}>
                                                    <CardHeader
                                                        sx={{ p: 1 }}
                                                        title={
                                                            <Grid item sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                <Typography variant="inherit" sx={{ fontWeight: "500", fontSize: "17px" }}>
                                                                    Record Submitted Date
                                                                </Typography>
                                                                <Tooltip title="Record sumbitted date filter need both from and to date." placement="top" arrow>
                                                                    <IconInfoCircleFilled style={{ color: "gray", cursor: "pointer" }} />
                                                                </Tooltip>
                                                            </Grid>
                                                        }
                                                    />
                                                    <CardContent sx={{ p: 1, pt: 1 }}>
                                                        <Grid container columnSpacing="16">
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="From Date"
                                                                        onChange={(date) => validateOnDate("submittedfrom", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.submittedfrom ? moment.utc(filter.submittedfrom, "DD-MM-YYYY") : null}
                                                                        maxDate={filter?.submittedto ? moment.utc(filter.submittedto, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.submittedfrom,
                                                                                helperText: errors?.submittedfrom
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="To Date"
                                                                        onChange={(date) => validateOnDate("submittedto", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.submittedto ? moment.utc(filter.submittedto, "DD-MM-YYYY") : null}
                                                                        minDate={filter?.submittedfrom ? moment.utc(filter.submittedfrom, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.submittedto,
                                                                                helperText: errors?.submittedto
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <VWDropdown
                                                    label="Location"
                                                    name="location"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadLocationOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.location ? filter.location.includes(",") ? filter.location.split(",") : [filter.location] : []}
                                                    options={locationOptions}
                                                    setOptions={setLocationOptions}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <VWDropdown
                                                    label="Region"
                                                    name="region"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadRegionOptions}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.region ? filter.region.includes(",") ? filter.region.split(",") : [filter.region] : []}
                                                    options={regionOptions}
                                                    setOptions={(options) => {
                                                        setRegionOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <VWDropdown
                                                    label="State/Export"
                                                    name="state"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadStateOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.state ? filter.state.includes(",") ? filter.state.split(",") : [filter.state] : []}
                                                    options={stateOptions}
                                                    setOptions={(options) => {
                                                        setStateOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <VWDropdown
                                                    label="District"
                                                    name="district"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadDistrictOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.district ? filter.district.includes(",") ? filter.district.split(",") : [filter.district] : []}
                                                    options={districtOptions}
                                                    setOptions={(options) => {
                                                        setDistrictOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Age"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='age'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    value={filter?.age}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Gut & Organ Images Count"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='totalBirdImageCount'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    inputProps={{ max: 10000000 }}
                                                    value={filter?.totalBirdImageCount}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Examined Birds Count"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='examinedbirdscount'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    inputProps={{ max: 10000000 }}
                                                    value={filter?.examinedbirdscount}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Total No Of Birds Placed"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='totalnoofbirdsplaced'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    inputProps={{ max: 10000000 }}
                                                    value={filter?.totalnoofbirdsplaced}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <VWDropdown
                                                    label="Anticoccidial"
                                                    name="anticoccidial"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadAnticoccidialOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.anticoccidial ? filter.anticoccidial.includes(",") ? filter.anticoccidial.split(",") : [filter.anticoccidial] : []}
                                                    options={anticoccidialOptions}
                                                    setOptions={(options) => {
                                                        setAnticoccidialOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <VWDropdown
                                                    label="AGP"
                                                    name="agp"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadAgpOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.agp ? filter.agp.includes(",") ? filter.agp.split(",") : [filter.agp] : []}
                                                    options={agpOptions}
                                                    setOptions={(options) => {
                                                        setAgpOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <VWDropdown
                                                    label="Probiotic"
                                                    name="probiotic"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadProbioticOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.probiotic ? filter.probiotic.includes(",") ? filter.probiotic.split(",") : [filter.probiotic] : []}
                                                    options={probioticOptions}
                                                    setOptions={(options) => {
                                                        setProbioticOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Remark"
                                                    fullWidth
                                                    size="small"
                                                    name='remark'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.remark}
                                                />
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12}>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ mt: 2, mb: 2 }}
                                                >
                                                    Note: Counts can only be entered up to <b>1,00,00,000</b>.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    farmRecordsFilterData: state.farmRecords.farmRecordsFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    //--------------------Filter--------------------------------------
    setFarmRecordsFilteredData: (filter) => dispatch(setFarmRecordsFilteredData(filter)),
    //--------------------Technical Manager---------------------------
    getTechnicalManagerOption: (filter, page, pageSize) => dispatch(getTechnicalManagerOption(filter, page, pageSize)),
    //--------------------Customer------------------------------------
    getCustomerOption: (filter, page, pageSize) => dispatch(getCustomerOption(filter, page, pageSize)),
    //--------------------Location------------------------------------
    getLocationOption: (filter, recordstatus) => dispatch(getLocationOption(filter, recordstatus)),
    //--------------------Region--------------------------------------
    getRegionOption: (filter, type, page, pageSize) => dispatch(getRegionOption(filter, type, page, pageSize)),
    //--------------------State---------------------------------------
    getStateOption: (filter, region, page, pageSize) => dispatch(getStateOption(filter, region, page, pageSize)),
    //--------------------District------------------------------------
    getDistrictOption: (filter, state, region, page, pageSize) => dispatch(getDistrictOption(filter, state, region, page, pageSize)),
    //--------------------Anticocidal---------------------------------
    getAnticocidalOption: (filter, page, pageSize) => dispatch(getAnticocidalOption(filter, page, pageSize)),
    //--------------------AGP-----------------------------------------
    getAGPOption: (filter, page, pageSize) => dispatch(getAGPOption(filter, page, pageSize)),
    //--------------------Probiotic-----------------------------------
    getProbioticOption: (filter, page, pageSize) => dispatch(getProbioticOption(filter, page, pageSize)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterUsers);